"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplyFunction = exports.Aggregate = exports.CarbonMix = exports.CarbonRegion = exports.Classifier = exports.DataType = exports.DATATYPE_DETAILS = void 0;
const utils_1 = require("./utils");
exports.DATATYPE_DETAILS = [
    {
        key: 0 /* DataTypeKey.UInt8 */,
        bytes: 1,
        nullValue: 255,
    },
    {
        key: 1 /* DataTypeKey.Int8 */,
        bytes: 1,
        nullValue: 127,
    },
    {
        key: 2 /* DataTypeKey.UInt16 */,
        bytes: 2,
        nullValue: 65535,
    },
    {
        key: 3 /* DataTypeKey.Int16 */,
        bytes: 2,
        nullValue: 32767,
    },
    {
        key: 4 /* DataTypeKey.UInt32 */,
        bytes: 4,
        nullValue: 4294967295,
    },
    {
        key: 5 /* DataTypeKey.Int32 */,
        bytes: 4,
        nullValue: 2147483647,
    },
    {
        key: 6 /* DataTypeKey.UInt64 */,
        bytes: 8,
        nullValue: NaN,
    },
    {
        key: 7 /* DataTypeKey.Int64 */,
        bytes: 8,
        nullValue: NaN,
    },
    {
        key: 8 /* DataTypeKey.Float32 */,
        bytes: 4,
        nullValue: NaN,
    },
    {
        key: 9 /* DataTypeKey.Float64 */,
        bytes: 8,
        nullValue: NaN,
    },
];
var DataType;
(function (DataType) {
    function fromKey(key) {
        return exports.DATATYPE_DETAILS[key];
    }
    DataType.fromKey = fromKey;
})(DataType = exports.DataType || (exports.DataType = {}));
// Decoding occurs more than encoding, so use number as key
const CLASSIFIER = {
    0: "electricity.export",
    1: "gas.consumption",
    2: "oil.level",
    3: "relative_humidity",
    4: "electricity.consumption",
    5: "temperature",
    6: "electricity.import",
    7: "electricity.consumption.cost",
    8: "gas.consumption.cost",
    9: "electricity.diversion",
    10: "electricity.generation",
    11: "battery",
    12: "illuminance",
    13: "points.competition",
    14: "wellness.activity.hourly",
    15: "heat.energy",
    16: "heat.energy.cost",
    17: "group.heat.summary",
    18: "group.heat.consumption",
    19: "group.energy.consumption",
    20: "group.energy.summary",
    21: "groups.energy.summary",
    22: "cool.energy",
    23: "cool.energy.cost",
    24: "group.meter-read.count",
    25: "balance.heat",
    26: "balance.electricity",
    27: "balance.cooling",
    28: "heat.forecast",
    29: "cooling.forecast",
    30: "electricity.forecast",
    31: "signal_strength",
    32: "battery_level",
    127: "carbon_intensity",
};
var Classifier;
(function (Classifier) {
    function decode(num) {
        const result = CLASSIFIER[num];
        if (result === undefined) {
            throw RangeError("Could not decode classifier");
        }
        return result;
    }
    Classifier.decode = decode;
    function encode(str) {
        const result = Object.entries(CLASSIFIER).find(([key, value]) => value === str);
        if (result === undefined) {
            throw RangeError("Could not encode classifier");
        }
        return Number(result[0]); //key
    }
    Classifier.encode = encode;
    function isClassifier(str) {
        const result = Object.entries(CLASSIFIER).find(([key, value]) => value === str);
        return result !== undefined;
    }
    Classifier.isClassifier = isClassifier;
})(Classifier = exports.Classifier || (exports.Classifier = {}));
exports.CarbonRegion = {
    F: 1,
    N: 2,
    A: 3,
    G: 4,
    C: 5,
    D: 6,
    P: 7,
    J: 8,
    L: 9,
    E: 10,
    M: 11,
    H: 12,
    B: 13,
    K: 14,
    EN: 15,
    SC: 16,
    WL: 17,
    GB: 18,
};
exports.CarbonMix = {
    INTENSITY: 1,
    BIOMASS: 2,
    COAL: 3,
    IMPORTS: 4,
    GAS: 5,
    NUCLEAR: 6,
    OTHER: 7,
    HYDRO: 8,
    SOLAR: 9,
    WIND: 10,
};
exports.Aggregate = {
    SUM: utils_1.sum,
    MAX: utils_1.max,
    MIN: utils_1.min,
    MEAN: utils_1.mean,
    VAR: utils_1.variance,
    STDDEV: utils_1.standardDeviation,
    MEDIAN: utils_1.median,
    COUNT: utils_1.count,
    PRODUCT: utils_1.product,
};
exports.ApplyFunction = {
    ADD: (a, b) => (a !== null && a !== void 0 ? a : 0) + (b !== null && b !== void 0 ? b : 0),
    SUBTRACT: (a, b) => (a !== null && a !== void 0 ? a : 0) - (b !== null && b !== void 0 ? b : 0),
    MULTIPLY: (a, b) => (a !== null && a !== void 0 ? a : 0) * (b !== null && b !== void 0 ? b : 0),
    DIVIDE: (a, b) => (a !== null && a !== void 0 ? a : 0) / (b !== null && b !== void 0 ? b : 1),
};
//# sourceMappingURL=types.js.map